import { render } from "./Styles.vue?vue&type=template&id=add729f8"
import script from "./Styles.vue?vue&type=script&lang=ts"
export * from "./Styles.vue?vue&type=script&lang=ts"
script.render = render

export default script